import { Box, Stack } from "@mui/material";
import Head from "next/head";
import React from "react";

import Logo from "../../../assets/images/logo_blue.svg";
import { ContentResizingContainer } from "../content-resizing-container/ContentResizingContainer";
import { AppFooter } from "../footer/AppFooter";

const CONTAINER_ID = "content-container";

interface IProps {
    title?: string;
    actions?: React.ReactNode;
    hideHeaderLogo?: boolean;
}

export const NoAuthLayout: React.FC<React.PropsWithChildren<IProps>> = ({
    title,
    children,
    actions,
    hideHeaderLogo,
}) => {
    return (
        <>
            <Head>
                <title>{title ? `${title} | Levro` : "Levro"}</title>
            </Head>
            <Stack
                alignItems="center"
                spacing={3}
                width="100%"
                minHeight="100%"
                py={3}
                sx={({
                    palette: {
                        backgroundColors: { appPrimary },
                    },
                }) => ({ background: appPrimary.main })}
            >
                <Stack
                    flex={1}
                    width="100%"
                    maxWidth={(theme) => theme.formMaxWidths.page}
                    px={{ xs: 0.5, sm: 3, lg: 5 }}
                    spacing={2}
                    alignItems="flex-start"
                >
                    <Stack alignItems="center" direction="row" justifyContent="space-between" width="100%">
                        {!hideHeaderLogo && <Logo height={40} />}
                        <Stack direction="row" spacing={1}>
                            {actions}
                        </Stack>
                    </Stack>

                    <Box id={CONTAINER_ID} flex={1} alignSelf="center" width="100%" paddingTop={3}>
                        {/* Necessary for our BorderedTable components - they need static width and no other overflow elements. */}
                        <ContentResizingContainer containerElementId={CONTAINER_ID}>
                            {children}
                        </ContentResizingContainer>
                    </Box>
                </Stack>
                <Box px={2}>
                    <AppFooter />
                </Box>
            </Stack>
        </>
    );
};
